// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__36oVd","title":"ClientInsurance_title__2NeCe","itemText":"ClientInsurance_itemText__IjJwV"};